import { Admin } from "~/features/admin/index.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useDeploymentType } from "~/shared/hooks/use-deployment-type.ts";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const AdminPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxLtlAdminPage");
	const { isInternal } = useDeploymentType();

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled && !isInternal ? <Admin /> : <Construction />;
};
